module.exports = __webpack_public_path__ + "img/uncommon.1a8b0925.png";